import React, {Component} from 'react';
import posed from 'react-pose';
import './Collapse.css';

const Content = posed.div({
  close: {
    height: 0,
    opacity: 0,
    marginBottom: '0px',
    transition: {
      duration: 400
    }
  },
  open: {
    height: 'auto',
    opacity: 1,
    marginBottom: '8px',
    transition: {
      duration: 400
    }
  }
});

class PageWrapper extends Component {

  constructor(props){
    super(props);
    this.state = { open: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    this.setState(prevState => ({
      open: !prevState.open
    }));
  }

  render(){
    let {header, children} = this.props;
    let {open} = this.state;
    return(
      <div className="PageWrapper">
        <div onClick={this.handleClick} className="PageWrapper-header">
          <div className="PageWrapper-header-text">
            {header}
          </div>
        </div>
        <div className="PageWrapper-content">
          <Content pose={open ? "open" : "close"}>
            {children}
          </Content>
          <div className="PageWrapper-border" />
        </div>
      </div>
    )
  }
}

export default PageWrapper;


// WEBPACK FOOTER //
// ./src/components/Collapse.js